export default function HomePage() {
  return (
    <main>
      {/* Hero Section */}
      <section className="relative h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20illustration%20with%20vibrant%20colors%2C%20beautiful%20anime%20characters%20floating%20in%20dreamy%20comic%20panel%20composition%2C%20artistic%20watercolor%20blend%20with%20modern%20digital%20art%2C%20soft%20gradient%20background%20with%20warm%20coral%20and%20golden%20tones%2C%20whimsical%20storytelling%20atmosphere%2C%20clean%20and%20elegant%20composition&width=1920&height=900&seq=hero-bg-main&orientation=landscape"
          alt="韩国漫画网 - 好看韩国漫画在线阅读"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
        <div className="relative z-10 w-full px-4 md:px-6 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide">
            韩国漫画网
          </h1>
          <p className="text-base md:text-xl text-white/85 max-w-2xl mx-auto leading-relaxed">
            发现众多好看韩国漫画，支持韩漫在线无删减下拉式免费阅读<br />
            为您提供原汁原味的完整漫画体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <a
              href="#hot-comics"
              className="px-8 py-3 bg-primary-500 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即阅读
            </a>
            <a
              href="#categories"
              className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white text-sm md:text-base font-medium rounded-full hover:bg-white/25 transition-all duration-300 border border-white/30 whitespace-nowrap cursor-pointer"
            >
              浏览分类
            </a>
          </div>
        </div>
      </section>

      {/* Stats Bar */}
      <section className="bg-white border-b border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 md:py-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8">
            {[
              { value: '50,000+', label: '漫画资源' },
              { value: '200万+', label: '日活跃用户' },
              { value: '8年', label: '稳定运营' },
              { value: '300万+', label: '漫画章节' },
            ].map((stat, idx) => (
              <div key={idx} className="text-center">
                <div className="text-xl md:text-3xl font-heading font-bold text-primary-600">{stat.value}</div>
                <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Category Navigation */}
      <section id="categories" className="py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
            漫画分类
          </h2>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {[
              { icon: 'ri-heart-line', name: '恋爱', slug: 'romance', color: 'primary' },
              { icon: 'ri-fire-line', name: '热血', slug: 'action', color: 'accent' },
              { icon: 'ri-magic-line', name: '奇幻', slug: 'fantasy', color: 'secondary' },
              { icon: 'ri-emotion-laugh-line', name: '搞笑', slug: 'comedy', color: 'primary' },
              { icon: 'ri-search-eye-line', name: '悬疑', slug: 'thriller', color: 'accent' },
              { icon: 'ri-movie-2-line', name: '剧情', slug: 'drama', color: 'secondary' },
              { icon: 'ri-building-2-line', name: '校园', slug: 'school', color: 'primary' },
              { icon: 'ri-ancient-gate-line', name: '古风', slug: 'historical', color: 'accent' },
            ].map((cat) => {
              const colorClasses = cat.color === 'primary'
                ? 'bg-primary-50 text-primary-700 hover:bg-primary-100'
                : cat.color === 'accent'
                ? 'bg-accent-50 text-accent-700 hover:bg-accent-100'
                : 'bg-secondary-50 text-secondary-700 hover:bg-secondary-100';
              return (
                <a
                  key={cat.slug}
                  href={`/category/${cat.slug}`}
                  className={`flex items-center gap-3 px-4 py-3.5 rounded-lg transition-colors cursor-pointer ${colorClasses}`}
                >
                  <i className={`${cat.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                  <span className="text-sm font-medium whitespace-nowrap">{cat.name}</span>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      {/* Featured / Hot Comics */}
      <section id="hot-comics" className="py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <a href="/category/all" className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer">
              查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
            {[
              { id: 1, title: '某天成为公主', author: 'Spoon', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20princess%20with%20long%20blonde%20hair%20wearing%20an%20elegant%20pink%20royal%20dress%20in%20a%20palace%20setting%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20detailed%20anime%20art%20style%2C%20clean%20illustration&width=600&height=800&seq=comic-01&orientation=portrait', rating: 9.5, chapters: 125, status: '连载中', views: 3850000, tags: ['宫廷', '穿越'] },
              { id: 2, title: '我独自升级', author: 'Chugong / DUBU', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20blue%20eyes%20wearing%20black%20combat%20armor%20in%20a%20dungeon%20setting%2C%20dark%20atmosphere%2C%20action%20vibes%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-02&orientation=portrait', rating: 9.8, chapters: 179, status: '已完结', views: 8920000, tags: ['战斗', '升级'] },
              { id: 3, title: '恶女的定义', author: 'Soohee / Gaya', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20villainess%20woman%20with%20red%20hair%20and%20sharp%20eyes%20wearing%20a%20luxurious%20dark%20gown%20holding%20a%20fan%2C%20dramatic%20lighting%2C%20rich%20colors%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-03&orientation=portrait', rating: 9.3, chapters: 98, status: '连载中', views: 2450000, tags: ['恶女', '宫廷'] },
              { id: 4, title: '女神降临', author: 'Yaongyi', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20gorgeous%20young%20woman%20with%20long%20brown%20hair%20and%20perfect%20makeup%20in%20a%20school%20uniform%2C%20bright%20and%20cheerful%20atmosphere%2C%20beauty%20transformation%20theme%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-04&orientation=portrait', rating: 9.1, chapters: 224, status: '已完结', views: 5680000, tags: ['化妆', '校园'] },
              { id: 5, title: '看脸时代', author: '朴泰俊', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20two%20contrasting%20male%20characters%20one%20handsome%20and%20one%20overweight%20in%20split%20composition%2C%20urban%20school%20setting%2C%20dramatic%20contrast%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-05&orientation=portrait', rating: 9.4, chapters: 312, status: '连载中', views: 7450000, tags: ['校园', '霸凌'] },
              { id: 6, title: '全知读者视角', author: 'Sing N Song', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20male%20protagonist%20with%20glasses%20holding%20a%20glowing%20book%20surrounded%20by%20apocalyptic%20scenery%2C%20dark%20atmosphere%20with%20monsters%2C%20detailed%20anime%20art%20style&width=600&height=800&seq=comic-06&orientation=portrait', rating: 9.7, chapters: 210, status: '连载中', views: 6230000, tags: ['末世', '冒险'] },
            ].map((comic) => {
              const viewsText = comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views.toString();
              return (
                <a key={comic.id} href={`/comic/${comic.id}`} className="group block bg-white rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer">
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img src={comic.cover} alt={comic.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                    <div className="absolute top-2 left-2 flex flex-wrap gap-1">
                      <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500 text-white whitespace-nowrap">{comic.rating}</span>
                      {comic.status === '已完结' && <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-accent-500 text-white whitespace-nowrap">完结</span>}
                    </div>
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                      <span className="text-xs text-white/80">{comic.chapters}话</span>
                    </div>
                  </div>
                  <div className="p-3">
                    <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-600 transition-colors">{comic.title}</h3>
                    <p className="text-xs text-foreground-500 mt-1 truncate">{comic.author}</p>
                    <div className="flex items-center gap-3 mt-2">
                      <span className="text-xs text-foreground-400 flex items-center gap-1">
                        <i className="ri-eye-line text-[11px] w-3.5 h-3.5 flex items-center justify-center"></i>{viewsText}
                      </span>
                      {comic.tags.slice(0, 2).map(tag => (
                        <span key={tag} className="px-1.5 py-0.5 text-[10px] rounded bg-secondary-100 text-secondary-700 whitespace-nowrap">{tag}</span>
                      ))}
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      {/* Bestseller Banner */}
      <section className="relative py-16 md:py-20 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panels%20collage%20with%20dramatic%20action%20scenes%2C%20warm%20gradient%20overlay%2C%20abstract%20comic%20book%20background%20with%20speed%20lines%20and%20halftone%20texture%2C%20cinematic%20composition%2C%20rich%20coral%20and%20deep%20navy%20tones&width=1920&height=600&seq=banner-bg-01&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/55"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
            百万读者共同选择
          </h2>
          <p className="text-base md:text-lg text-white/75 max-w-2xl mx-auto mb-8">
            海量韩国漫画资源，每日同步更新，无删减下拉式阅读体验。无论你喜欢恋爱、热血还是悬疑，这里都有属于你的精彩世界。
          </p>
          <a href="/category/all" className="inline-flex px-8 py-3 bg-accent-500 text-white text-sm md:text-base font-semibold rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer">
            探索全部漫画
          </a>
        </div>
      </section>

      {/* Latest Updates */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
            最新更新
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { id: 5, title: '看脸时代', author: '朴泰俊', chapter: '第312话', date: '2026-08-05', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panel%20showing%20dramatic%20school%20confrontation%20scene%20with%20intense%20expressions%2C%20modern%20Korean%20high%20school%20setting%2C%20anime%20style%2C%20dramatic%20lighting&width=400&height=250&seq=update-01&orientation=landscape' },
              { id: 6, title: '全知读者视角', author: 'Sing N Song', chapter: '第210话', date: '2026-08-04', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panel%20showing%20apocalyptic%20battle%20scene%20with%20monsters%20and%20heroes%2C%20dark%20atmosphere%2C%20anime%20style%2C%20epic%20composition&width=400&height=250&seq=update-02&orientation=landscape' },
              { id: 1, title: '某天成为公主', author: 'Spoon', chapter: '第125话', date: '2026-08-04', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panel%20showing%20warm%20family%20scene%20in%20palace%20garden%20with%20father%20and%20daughter%2C%20soft%20pastel%20colors%2C%20romantic%20anime%20style%2C%20gentle%20atmosphere&width=400&height=250&seq=update-03&orientation=landscape' },
              { id: 9, title: '搞笑一家人', author: '李末年', chapter: '第198话', date: '2026-08-04', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panel%20showing%20funny%20family%20dinner%20scene%20with%20chaotic%20expressions%2C%20warm%20home%20setting%2C%20comedy%20anime%20style%2C%20colorful%20lively%20composition&width=400&height=250&seq=update-04&orientation=landscape' },
              { id: 11, title: '重生之都市修仙', author: '方圆', chapter: '第345话', date: '2026-08-05', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panel%20showing%20urban%20fantasy%20scene%20with%20cultivator%20using%20powers%20in%20modern%20city%2C%20mystical%20energy%20effects%2C%20anime%20style%2C%20dynamic%20composition&width=400&height=250&seq=update-05&orientation=landscape' },
              { id: 15, title: '放学后的特别课程', author: 'Narak', chapter: '第64话', date: '2026-08-03', cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20panel%20showing%20romantic%20after%20school%20classroom%20scene%20with%20sunset%20lighting%2C%20two%20students%2C%20warm%20atmosphere%2C%20anime%20style%2C%20tender%20mood&width=400&height=250&seq=update-06&orientation=landscape' },
            ].map((update) => (
              <a key={update.id} href={`/comic/${update.id}`} className="flex items-center gap-4 p-4 bg-white rounded-lg hover:bg-background-50 transition-colors cursor-pointer">
                <img src={update.cover} alt={update.title} className="w-20 md:w-24 h-14 md:h-16 rounded-md object-cover flex-shrink-0" loading="lazy" />
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{update.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5">{update.author}</p>
                  <div className="flex items-center gap-3 mt-1.5">
                    <span className="text-xs text-primary-600 font-medium">{update.chapter}</span>
                    <span className="text-xs text-foreground-400">{update.date}</span>
                  </div>
                </div>
                <div className="flex-shrink-0">
                  <span className="px-3 py-1.5 text-xs font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">阅读</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Ranking Section */}
      <section className="py-10 md:py-14">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-8">
            人气排行榜
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg border border-background-200/70 p-5">
              <h3 className="text-base font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                <i className="ri-fire-line text-accent-500 w-5 h-5 flex items-center justify-center"></i>
                热门榜 TOP 8
              </h3>
              <div className="space-y-3">
                {[
                  { rank: 1, title: '我独自升级', author: 'Chugong', rating: 9.8 },
                  { rank: 2, title: '全知读者视角', author: 'Sing N Song', rating: 9.7 },
                  { rank: 3, title: '北剑神皇', author: '海洋', rating: 9.6 },
                  { rank: 4, title: '某天成为公主', author: 'Spoon', rating: 9.5 },
                  { rank: 5, title: '看脸时代', author: '朴泰俊', rating: 9.4 },
                  { rank: 6, title: '魔咒', author: 'Honey B', rating: 9.4 },
                  { rank: 7, title: '恶女的定义', author: 'Soohee', rating: 9.3 },
                  { rank: 8, title: '李氏朝鲜秘史', author: '金载沅', rating: 9.3 },
                ].map((item, index) => {
                  const comicId = [2, 6, 8, 1, 5, 16, 3, 13][index];
                  return (
                    <a key={item.rank} href={`/comic/${comicId}`} className="flex items-center gap-3 py-2 hover:bg-background-50 rounded-md px-2 -mx-2 transition-colors cursor-pointer">
                      <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${item.rank <= 3 ? 'bg-primary-500 text-white' : 'bg-background-100 text-foreground-500'}`}>
                        {item.rank}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-foreground-900 truncate">{item.title}</p>
                        <p className="text-xs text-foreground-500">{item.author}</p>
                      </div>
                      <span className="flex-shrink-0 text-xs font-semibold text-primary-600">{item.rating}</span>
                    </a>
                  );
                })}
              </div>
            </div>

            <div className="bg-white rounded-lg border border-background-200/70 p-5">
              <h3 className="text-base font-semibold text-foreground-900 mb-4 flex items-center gap-2">
                <i className="ri-thumb-up-line text-primary-500 w-5 h-5 flex items-center justify-center"></i>
                新作榜 TOP 8
              </h3>
              <div className="space-y-3">
                {[
                  { rank: 1, title: '重生之都市修仙', author: '方圆', rating: 9.1 },
                  { rank: 2, title: '甜蜜的陷阱', author: '朴慧琳', rating: 8.8 },
                  { rank: 3, title: '放学后的特别课程', author: 'Narak', rating: 8.7 },
                  { rank: 4, title: '幽灵医生', author: '李贤秀', rating: 9.0 },
                  { rank: 5, title: '杀人者的购物中心', author: '姜草', rating: 9.2 },
                  { rank: 6, title: '魔咒', author: 'Honey B', rating: 9.4 },
                  { rank: 7, title: '她的私生活', author: '金成妍', rating: 8.9 },
                  { rank: 8, title: '搞笑一家人', author: '李末年', rating: 9.0 },
                ].map((item, index) => {
                  const comicId = [11, 12, 15, 14, 10, 16, 7, 9][index];
                  return (
                    <a key={item.rank} href={`/comic/${comicId}`} className="flex items-center gap-3 py-2 hover:bg-background-50 rounded-md px-2 -mx-2 transition-colors cursor-pointer">
                      <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold ${item.rank <= 3 ? 'bg-accent-500 text-white' : 'bg-background-100 text-foreground-500'}`}>
                        {item.rank}
                      </span>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-foreground-900 truncate">{item.title}</p>
                        <p className="text-xs text-foreground-500">{item.author}</p>
                      </div>
                      <span className="flex-shrink-0 text-xs font-semibold text-accent-600">{item.rating}</span>
                    </a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8">
            常见问题
          </h2>
          <div className="space-y-3">
            {[
              { q: '韩国漫画网上的漫画都是免费的吗？', a: '是的，韩国漫画网上所有漫画均提供免费在线观看服务。我们致力于为广大韩漫爱好者提供优质、无删减的漫画阅读体验，无需付费即可畅享海量韩国漫画资源。' },
              { q: '网站上的漫画更新频率如何？', a: '我们与多家韩国漫画平台保持紧密合作，漫画更新与韩国本土保持同步。热门连载漫画通常每周更新1-2话，确保您能够第一时间看到最新的韩漫内容。' },
              { q: '为什么选择下拉式阅读方式？', a: '下拉式（Webtoon）是韩国漫画的主流阅读形式，相比传统的翻页式漫画，下拉式阅读更加流畅自然，特别适合在手机和电脑上阅读。所有漫画画面完整呈现，无需缩放，为您带来最舒适的阅读体验。' },
              { q: '漫画是否有删减或修改？', a: '我们始终坚持提供原汁原味的韩国漫画内容，所有漫画均为无删减版本。我们尊重创作者的原始表达，保留完整的故事情节和画面，让读者能够完整体验漫画的魅力。' },
            ].map((faq, idx) => (
              <details key={idx} className="bg-white rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm font-medium text-foreground-900 list-none">
                  {faq.q}
                  <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}